import React from "react";

import styles from "./SortDropdown.module.scss";

interface SortDropdownProps {}

const SortDropdown: React.FC<SortDropdownProps> = () => {
  const [isActive, setIsActive] = React.useState(false);

  return (
    <div className={isActive ? `${styles.dropdown} ${styles.active}` : styles.dropdown} onClick={() => setIsActive(!isActive)}>
      <div className={styles.title}>
        <h2>Сначала новинки</h2>
        <div className={styles.arrow}>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M19.9201 9.72998L13.4001 16.25C12.6301 17.02 11.3701 17.02 10.6001 16.25L4.08008 9.72998"
              stroke="#9D9595"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
      <ul className={styles.content}>
        <li>Сначала популярные</li>
        <li>Сначала новинки</li>
        <li>По цене (сначала дешёвые)</li>
        <li>По цене (сначала дорогие)</li>
      </ul>
    </div>
  );
};

export default SortDropdown;
